<div class="aws-costos-container">
  <!-- Preloader -->
  <app-preloader *ngIf="loadingService.loading$ | async"></app-preloader>

  <!-- Header Section -->
  <div class="header-section">
    <div class="header-content">
      <div class="header-title">
        <svg class="header-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
        <div>
          <h1>Costos AWS</h1>
          <p class="subtitle">Análisis de costos y tendencias</p>
        </div>
      </div>
    </div>

    <!-- Month Selectors -->
    <div class="month-selectors">
      <div class="selector-group">
        <label for="mesReferencia">Mes de referencia</label>
        <select id="mesReferencia" [(ngModel)]="mesReferencia" (ngModelChange)="onMesReferenciaChange()">
          <option *ngFor="let opt of monthOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
      </div>
      <div class="selector-group">
        <label for="mesComparacion">Mes de comparación</label>
        <select id="mesComparacion" [(ngModel)]="mesComparacion" disabled>
          <option *ngFor="let opt of monthOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
      </div>
      <div class="selector-group">
        <label for="kpiMensual">KPI Mensual (USD)</label>
        <input id="kpiMensual" type="number" [(ngModel)]="kpiMensual" min="0" step="1000" />
      </div>
      <button class="consult-btn" (click)="loadCostData()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        Consultar
      </button>
      <button class="export-pdf-btn" (click)="exportToPDF()" *ngIf="hasData" [disabled]="isExporting">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        {{ isExporting ? 'Generando...' : 'Exportar PDF' }}
      </button>
    </div>
  </div>

  <!-- Error Message -->
  <div class="error-message" *ngIf="errorMessage && !hasData">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <p>{{ errorMessage }}</p>
  </div>

  <!-- Content -->
  <div class="content-wrapper" #contentWrapper *ngIf="hasData">
    <!-- KPI Compliance Card -->
    <div class="kpi-compliance-card" *ngIf="kpiMensual > 0">
      <div class="kpi-header">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h3>Cumplimiento KPI — {{ kpiUltimoMesLabel }} {{ refYear }}</h3>
      </div>
      <div class="kpi-body">
        <div class="kpi-status" [class.cumple]="kpiCumple" [class.no-cumple]="!kpiCumple">
          <span class="kpi-status-icon">{{ kpiCumple ? '\u2714' : '\u2716' }}</span>
          <span class="kpi-status-text">{{ kpiCumple ? 'Cumple' : 'No cumple' }}</span>
        </div>
        <div class="kpi-details">
          <div class="kpi-detail-item">
            <span class="kpi-label">KPI Objetivo</span>
            <span class="kpi-value">${{ kpiMensual.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</span>
          </div>
          <div class="kpi-detail-item">
            <span class="kpi-label">Costo {{ kpiUltimoMesLabel }}</span>
            <span class="kpi-value">${{ kpiCostoUltimoMes.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="summary-cards">
      <div class="summary-card" *ngFor="let year of ['Total 2024', 'Total 2025', 'Total 2026']">
        <div class="card-header">
          <span class="year-label">{{ year.replace('Total ', '') }}</span>
          <div class="year-indicator" [style.background-color]="getYearColor(year)"></div>
        </div>
        <div class="card-amount">
          ${{ getTotalCostByYear(year).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
        </div>
        <div class="card-footer">
          <span class="months-count">{{ costData[year]?.length || 0 }} meses</span>
          <span class="year-percentage">{{ getYearPercentage(year).toFixed(1) }}%</span>
        </div>
      </div>
    </div>

    <!-- Marketplace Toggle & Info -->
    <div class="marketplace-card" *ngIf="hasMarketplaceData">
      <div class="marketplace-info">
        <div class="marketplace-header">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <div>
            <h3>Costos de Marketplace</h3>
            <p>Suscripciones de terceros (AWS Marketplace) incluidas en los totales</p>
          </div>
        </div>
        <div class="marketplace-amounts">
          <div class="mp-amount-item">
            <span class="mp-label">{{ mesReferenciaLabel }}</span>
            <span class="mp-value">${{ marketplaceRefCost.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</span>
          </div>
          <div class="mp-amount-item">
            <span class="mp-label">{{ mesComparacionLabel }}</span>
            <span class="mp-value">${{ marketplaceCompCost.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</span>
          </div>
        </div>
      </div>
      <label class="marketplace-toggle" [class.excluded]="!includeMarketplace">
        <input type="checkbox" [(ngModel)]="includeMarketplace" />
        <span class="toggle-slider"></span>
        <span class="toggle-text">{{ includeMarketplace ? 'Incluyendo Marketplace' : 'Excluyendo Marketplace' }}</span>
      </label>
    </div>

    <!-- Charts Section -->
    <div class="charts-grid">
      <!-- Bar Chart -->
      <div class="chart-card">
        <div class="chart-header">
          <h3>Costos Mensuales — {{ mesReferenciaLabel }} vs {{ mesComparacionLabel }}</h3>
          <p>Comparativa por año con KPI de referencia</p>
          <label class="kpi-line-toggle" *ngIf="kpiMensual > 0">
            <input type="checkbox" [(ngModel)]="showKpiLine" (ngModelChange)="toggleKpiLine()" />
            <span>Mostrar línea KPI</span>
          </label>
        </div>
        <div class="chart-wrapper">
          <div id="barChart"></div>
        </div>
      </div>

      <!-- Monthly Comparison Chart -->
      <div class="chart-card" *ngIf="costData?.monthly_comparison">
        <div class="chart-header">
          <h3>Comparación Diaria — {{ costData.monthly_comparison.current_month.month_name }} {{ costData.monthly_comparison.current_month.year }} vs {{ costData.monthly_comparison.previous_month.month_name }} {{ costData.monthly_comparison.previous_month.year }}</h3>
          <p>Costos diarios mes referencia vs mes comparación</p>
          <div class="comparison-stats">
            <div class="stat-month">
              <span class="stat-month-label">{{ costData.monthly_comparison.previous_month.month_name }}:</span>
              <span class="stat-month-value">${{ compMonthTotal.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</span>
            </div>
            <div class="stat-month">
              <span class="stat-month-label">{{ costData.monthly_comparison.current_month.month_name }}:</span>
              <span class="stat-month-value">${{ refMonthTotal.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</span>
            </div>
            <span class="stat-badge" [class.positive]="monthDifference < 0" [class.negative]="monthDifference > 0">
              <svg *ngIf="monthDifference < 0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6" />
              </svg>
              <svg *ngIf="monthDifference > 0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
              </svg>
              {{ monthPercentageChange > 0 ? '+' : '' }}{{ monthPercentageChange.toFixed(2) }}%
            </span>
            <span class="stat-value">
              {{ monthDifference > 0 ? '+' : '' }}${{ Math.abs(monthDifference).toLocaleString('en-US', { minimumFractionDigits: 2 }) }}
            </span>
            <span class="mp-excluded-chip" *ngIf="hasMarketplaceData && !includeMarketplace">sin Marketplace</span>
          </div>
        </div>
        <div class="chart-wrapper">
          <div id="comparisonChart"></div>
        </div>
      </div>
    </div>

    <!-- AI Analysis Section -->
    <div class="ai-analysis-section" *ngIf="aiAnalysis">
      <div class="analysis-header">
        <h2>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
          Análisis Inteligente de Costos
        </h2>
      </div>

      <!-- Resumen Ejecutivo -->
      <div class="analysis-card summary-card-ai">
        <div class="card-icon-header">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          <h3>Resumen Ejecutivo</h3>
          <span class="mp-excluded-chip" *ngIf="hasMarketplaceData && !includeMarketplace">sin Marketplace</span>
        </div>
        <div class="summary-grid-ai">
          <div class="summary-item-ai">
            <span class="label">Mes Reciente</span>
            <span class="value primary">{{ aiAnalysis.resumen_ejecutivo.mes_reciente }}</span>
          </div>
          <div class="summary-item-ai">
            <span class="label">Mes Comparación</span>
            <span class="value">{{ aiAnalysis.resumen_ejecutivo.mes_comparacion }}</span>
          </div>
          <div class="summary-item-ai">
            <span class="label">Costo Mes Reciente</span>
            <span class="value primary">${{ resumenCostoReciente.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</span>
          </div>
          <div class="summary-item-ai">
            <span class="label">Costo Mes Comparación</span>
            <span class="value">${{ resumenCostoComparacion.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</span>
          </div>
          <div class="summary-item-ai highlight">
            <span class="label">Diferencia</span>
            <span class="value" [class.positive]="resumenDiferencia < 0" [class.negative]="resumenDiferencia > 0">
              {{ resumenDiferencia > 0 ? '+' : '' }}${{ Math.abs(resumenDiferencia).toLocaleString('en-US', { minimumFractionDigits: 2 }) }}
            </span>
          </div>
          <div class="summary-item-ai highlight">
            <span class="label">Variación</span>
            <span class="value" [class.positive]="resumenPorcentaje < 0" [class.negative]="resumenPorcentaje > 0">
              {{ resumenPorcentaje > 0 ? '+' : '' }}{{ resumenPorcentaje.toFixed(2) }}%
            </span>
          </div>
        </div>
      </div>

      <!-- Sección 1: Comparativa -->
      <div class="analysis-card">
        <div class="card-icon-header">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <h3>{{ aiAnalysis.seccion_1_comparativa.titulo }}</h3>
        </div>
        <div class="analysis-subsection" *ngFor="let punto of aiAnalysis.seccion_1_comparativa.puntos">
          <h4>{{ punto.titulo }}</h4>
          <p class="description">{{ punto.descripcion }}</p>
        </div>
      </div>

      <!-- Sección 2: Variación por Servicios -->
      <div class="analysis-card">
        <div class="card-icon-header">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
          </svg>
          <h3>{{ aiAnalysis.seccion_2_variacion_servicios.titulo }}</h3>
        </div>
        <div class="services-list">
          <div class="service-item" *ngFor="let servicio of aiAnalysis.seccion_2_variacion_servicios.servicios">
            <div class="service-header">
              <span class="service-name">{{ servicio.nombre }}</span>
              <div class="service-badges">
                <span class="type-badge" [ngClass]="servicio.tipo">{{ getTipoBadgeText(servicio.tipo) }}</span>
                <span class="amount-badge" [class.positive]="servicio.tipo === 'reduccion'" [class.negative]="servicio.tipo === 'aumento'">
                  {{ servicio.monto_cambio }}
                </span>
              </div>
            </div>
            <p class="service-description">{{ limpiarDescripcion(servicio.descripcion, servicio.monto_cambio) }}</p>
            
            <!-- Campo de análisis para servicios con aumento (rojo) -->
            <div class="service-analysis-wrapper" *ngIf="servicio.tipo === 'aumento' && !isExporting">
              <div class="analysis-label">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                Análisis del incremento:
              </div>
              <textarea
                [(ngModel)]="serviciosAnalisis[servicio.nombre]"
                class="service-analysis-textarea"
                placeholder="Describa las razones del incremento en este servicio..."
                rows="3"
                [attr.aria-label]="'Análisis del incremento para ' + servicio.nombre"
                [class.has-content]="serviciosAnalisis[servicio.nombre]"></textarea>
              <div class="analysis-char-count" *ngIf="serviciosAnalisis[servicio.nombre]">
                {{ serviciosAnalisis[servicio.nombre].length }} caracteres
              </div>
            </div>
            
            <!-- Vista para PDF de análisis -->
            <div class="service-analysis-pdf" *ngIf="servicio.tipo === 'aumento' && isExporting && serviciosAnalisis[servicio.nombre]">
              <div class="analysis-pdf-header">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <strong>Análisis del incremento:</strong>
              </div>
              <p class="analysis-pdf-text">{{ serviciosAnalisis[servicio.nombre] }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección 3: Proyección -->
      <div class="analysis-card projection-card">
        <div class="card-icon-header">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
          <h3>{{ aiAnalysis.seccion_3_proyeccion.titulo }}</h3>
        </div>
        <div class="projection-content">
          <div class="projection-estimate">
            <div class="estimate-item">
              <span class="estimate-label">Estimado Mínimo</span>
              <span class="estimate-value">${{ aiAnalysis.seccion_3_proyeccion.estimado_cierre.minimo.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</span>
            </div>
            <div class="estimate-separator">—</div>
            <div class="estimate-item">
              <span class="estimate-label">Estimado Máximo</span>
              <span class="estimate-value">${{ aiAnalysis.seccion_3_proyeccion.estimado_cierre.maximo.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</span>
            </div>
          </div>
          <div class="projection-trend">
            <span class="trend-label">Tendencia:</span>
            <span class="trend-badge">{{ aiAnalysis.seccion_3_proyeccion.tendencia }}</span>
          </div>
          <div class="projection-analysis">
            <h4>Análisis Detallado</h4>
            <p>{{ aiAnalysis.seccion_3_proyeccion.analisis_detallado }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Services Cost Comparison -->
    <div class="services-comparison-section" *ngIf="costsByServiceCurrent.length > 0">
      <div class="section-header">
        <h2>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          Costos por Servicio — {{ mesReferenciaLabel }} vs {{ mesComparacionLabel }}
        </h2>
        <p class="section-subtitle">Top 15 servicios con mayor costo</p>
      </div>
      <div class="services-table-container">
        <table class="services-table">
          <thead>
            <tr>
              <th>Servicio</th>
              <th>Costo {{ mesReferenciaLabel }}</th>
              <th>Costo {{ mesComparacionLabel }}</th>
              <th>Diferencia</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let service of costsByServiceCurrent.slice(0, 15); let i = index">
              <td class="service-name-cell">{{ service.service }}</td>
              <td class="amount-cell">${{ service.cost.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</td>
              <td class="amount-cell">${{ getServicePreviousCost(service.service).toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</td>
              <td class="diff-cell">
                <span class="diff-badge" [class.positive]="getServiceDifference(service.service) < 0" [class.negative]="getServiceDifference(service.service) > 0">
                  {{ getServiceDifference(service.service) > 0 ? '+' : '' }}${{ Math.abs(getServiceDifference(service.service)).toLocaleString('en-US', { minimumFractionDigits: 2 }) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
